<template>
    <div class="container login py-5">
        <div class="row justify-content-center">
            <div class="card col-lg-6 col-12 py-3 shadow mb-5">
                <div class="card-body text-center">
                    <div class="row justify-content-center">
                        <div class="col-8 col-sm-6 mb-3">
                            <a href="/">
                                <img :src="brandLogoRegular" alt="Logo" class="img-fluid">
                            </a>
                        </div>
                    </div>

                    <div v-if="loading && !initialized" class="text-center">
                        <p>{{ $t("Laster...") }}</p>
                    </div>

                    <div v-else class="tabs-panel-group accordion mb-2" id="booking-accordions" role="tablist"
                         aria-multiselectable="true">
                        <h2 class="fw-bold">
                            {{ $t('Registrering hos') }} <br>
                            {{ officeName }}
                        </h2>

                        <h6 v-html="welcomeText"></h6>

                        <WizardStep1 :is-active="activeAccordion === 1"/>
                        <WizardStep2 :is-active="activeAccordion === 2"/>
                        <WizardStep3 :is-active="activeAccordion === 3"/>
                        <WizardStep4 :is-active="activeAccordion === 4"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { computed, onMounted } from 'vue'
    import wizardStore from '../../state/vippsWizardStore.js'
    import WizardStep1 from './WizardStep1.vue'
    import WizardStep2 from './WizardStep2.vue'
    import WizardStep3 from './WizardStep3.vue'
    import WizardStep4 from './WizardStep4.vue'

    const props = defineProps({
        brandLogoRegular: String,
        hash: String,
    })

    // Computed properties
    const loading = computed(() => wizardStore.state.loading.value)
    const initialized = computed(() => wizardStore.state.initialized.value)
    const officeName = computed(() => wizardStore.state.officeName.value)
    const welcomeText = computed(() => wizardStore.state.welcomeText.value)
    const activeAccordion = computed(() => wizardStore.state.activeAccordion.value)

    onMounted(async () => {
        if (props.hash) {
            await wizardStore.initializeFromAPI(props.hash)
        } else {
            wizardStore.showError('Invalid registration link')
        }
    })
</script>
